<div class="ops-active-projects-stats">
  <label>{{ 'auth.activeProjectsStats.activeProjects' | translate }}</label>

  <div class="used-from-limit" *ngIf="isLoading">
    <div class="cssload-container">
      <div class="cssload-speeding-wheel"></div>
    </div>
  </div>
  <div class="used-from-limit" *ngIf="!isLoading">
    {{
      activeCompanySubscription?.currentProjects
    }}&MediumSpace;/&MediumSpace;{{
      activeCompanySubscription?.maxRealProjectsInCompany
    }}
  </div>
</div>
